// extracted by mini-css-extract-plugin
module.exports = {"inputMain":"Input_inputMain__1dXbi","inputInput":"Input_inputInput__3VTfF","inputLabel":"Input_inputLabel__DWKp3"};